
export const API_LIMIT = 10
export const MAX_LIMIT = 10000
export const START_PAGE = 1
export const DEFAULT_LIST = { list: [], length: 0 }
export const YesNoOptions = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" }
];
export const ONLINE = "Online";
// export const TOOLS = "tools";
export const IN_PERSON = "In Person";

export const Thefinpedia = "Thefinpedia";
export const MUTUAL_FUND_COMPANY = "Mutual Fund Company";

export const ALT_CIRCLE = "circle image";
export const ALT_THUMBNAIL = "thumbnail image";
export const ALT_BANNER = "banner image";
export const FULLVIDEO = "FULL-VIDEO";
export const NoBranding = 'No Branding';

export const CREATEACCESS = "createAccess";
export const UPDATEACCESS = "updateAccess";
export const READEACCESS = "readAccess";
export const DELATEACCESS = "deleteAccess";
export const VALIDATEACCESS = 'validateAccess';
export const CAROUSEL = 'CAROUSEL';
export const SOCIALMEDIA_URL = "website/socialMedia/list";
export const SELECT_ROLE_TYPE = 'Select Role Type';

export const SUPER_ADMIN = 'super admin';
export const SUPERADMIN = 'Superadmin';
export const CHECKER = 'checker';
export const MAKER = 'maker';
export const SSO = 'sso';
export const MARKET_PLACE = '2a042be9-dc98-4ed7-8168-17686f05d6c5';
export const CREATOR_ID = "6f3c9c6e-3e0d-11ee-a134-00ffb10a2847";

export const IMAGEFILETYPE = "image/*"

export const ACCEPTEDFILETYPE = {
  VIDEOS: "video/*,.mkv",
  INFOGRAPHICS: "application/pdf,image/*",
  MINIMALISTS: "image/*",
  MINIMALIST: "image/*",
  PRESENTATIONS: ".ppt,.pptx,.pdf",
  PRESENTATION: ".ppt,.pptx,.pdf",
  PODCASTS: "audio/*,video/*,.mkv",
  REPORTS: ".pdf,.doc,.docx",
  EBOOKS: ".pdf",
  'E-BOOKS': ".pdf",
  EMAILERS: "image/*",
  CAROUSEL: "application/pdf,image/*",
  ARTICLES: ".pdf,.doc,.docx",
  REELS: "video/*,.mkv",
}
export const MODALFILETYPE = {
  IMAGE: "image/*",
  VIDEO: "video/*,.mkv",

}
export const FILETYPENAME = {
  IMAGEFILE: ".png,.jpg,.jpeg",
  VIDEOS: ".mp4,.mkv",
  REELS: ".mp4,.mkv",
  INFOGRAPHICS: ".pdf",
  infographics: ".pdf",
  MINIMALISTS: "image",
  MINIMALIST: "image",
  PRESENTATIONS: ".ppt,.pptx,.pdf",
  // PRESENTATION :"presentation",
  PRESENTATION: ".ppt,.pptx,.pdf",
  PODCASTS: "audio,.mp4,.mkv",
  REPORTS: "pdf,doc,docx",
  EBOOKS: "pdf",
  // 'E-BOOKS': "pdf",
  'E-BOOKS': ".pdf",
  EMAILERS: "image",
  CAROUSEL: ".pdf,.png,.jpg,.jpeg",
  ARTICLES: ".pdf,.doc,.docx"
};
export const filterOptions = [

  { label: "LOGO", value: "Logo" },
  { label: "COMPANY", value: "Company" },
  { label: "CUSTOM", value: "Custom" },
]
export const modalOptions = [

  { label: "IMAGE", value: "IMAGE" },
  { label: "VIDEO", value: "VIDEO" },
  { label: "YOUTUBE", value: "YOUTUBE" },
  { label: "TEXT", value: "TEXT" },

]
export const Trending = "Trending";
export const PREMIUM = "Premium";
export const NON_PREMIUM = "Free";

export const DOWNLOAD = 'Download';
export const COBRAND = 'Cobrand';

export const uploadFrequency = [
  { label: "Fortnightly", value: "15.00" },
  { label: "Weekly", value: "7.00" },
  { label: "Bi-Weekly", value: "3.50" },
  { label: "Daily", value: "1.00" },
  { label: "As and When ", value: "0.00" },


];
export const subscriptionDuration = [
  { label: "7 Days", value: "7" },
  { label: "15 Days", value: "15" },
  { label: "1 Month", value: "30" },
  { label: "3 Months", value: "90" },
  { label: "6 Months", value: "180" },
  { label: "1 Year", value: "365" },
  { label: "10 Years", value: "3650" },
];

export const uploadFrequencies = {
  "7.00": "Weekly",
  "3.50": "Bi-Weekly",
  "15.00": "Fortnightly",
  '1.00': 'Daily',
  '10': 'As and When',
};

export const subTrending = {
  trendingKeywords: 'Trending Keywords',
  manual: 'Manual',
  systemGenerated: 'System Generated',
}
export const TrendingType = {
  INSTAGRAM: "INSTAGRAM",
  FACEBOOK: "FACEBOOK",
  LINKEDIN: "LINKEDIN",
  X: "X",
  OTHER: "OTHER"
};
export const MODULES = {
  LANGUAGE: "LANGUAGE", //
  EVENT: "EVENT", //
  CONTENT: "CONTENT", //
  CAMPAIGN: "CAMPAIGN", //
  TARGETED_CONTENT: "TARGETED-CONTENT", //
  CATEGORY: "CATEGORY", //
  TOOLS: "TOOLS", //
  PERSONALIZE: "PERSONALIZE", //
  NOTIFICATION: "NOTIFICATION",
  POST_PLANNER: "POST-PLANNER", //
  AUTO_COBRAND: "AUTO-COBRAND", //
  SEARCH: "SEARCH",
  SOCIAL_MEDIA: "SOCIAL-MEDIA", //
  TRENDING: "TRENDING", //
  DASHBOARD: "DASHBOARD", //
  CALENDAR: "CALENDAR", //
}

export const publishOptions = [

]

export const NumberOfDays = [
  // { label: "Plan expiry", value: "0" },
  { label: "Daily", value: "1" },
  { label: "Monthly", value: "30" },
  { label: "Quarterly", value: "90" },
  { label: "Half Yearly", value: "180" },
  { label: "Yearly", value: "365" },
]

export const Validity = [

  { label: "Monthly", value: "30" },
  { label: "Quarterly", value: "90" },
  { label: "Half Yearly", value: "180" },
  { label: "Plan Expiry", value: "0" },
]

export const groupBy = (data, key) => {
  return data.reduce((acc, item) => {
    const group = item[key];

    if (!acc[group]) {
      acc[group] = [];
    }

    acc[group].push(item);

    return acc;
  }, {});
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const EventType = {
  FREE: 'Free',
  PAID: 'Paid',
  SPONSORED: 'Sponsored'
}
export const durationObj = {
  "30": "Monthly",
  "90": "Quarterly",
  "180": "Half Yearly",
  "365": "Yearly",
  '1': 'Daily',
  '0': "Plan expiry",
  "3650": "Lifetime"
}
export const PackOptions = [
  { label: "5", value: "5" },
  { label: "10", value: "10" },
  { label: "15", value: "15" },
  { label: "20", value: "20" },
  { label: "30", value: "30" },


]
export const TYPE_OPTION = [
  { label: 'EVENT', value: "Event" },
  { label: 'CONTENT', value: "Content" },
  { label: 'TOOLS', value: "Tools" },
  { label: 'PERSONALIZATION', value: "Personalization" },

]

// export const subPremiumPlanTestData = {
//   "name": "Siver",
//   "subPremiumPlanVariation": [
//     {
//       "title": "monthly",
//       "description": "<p>https://Yesh.com/<br>abcd efght <strong>this is not faire ererererer fdf</strong><del><strong>fdfafadfaf</strong></del><code><strong>fdafdafdfdf</strong></code></p>\n",
//       "price": 5000,
//       "discountedPrice": 4000,
//       "resetInDays": 180,
//       "subPremiumPlanVariationSpecification": [
//         {
//           "type": "content",
//           "contentType": ["4d25bcb8-5372-11ee-a6a5-b48c9dd517c6", "4d25bac3-5372-11ee-a6a5-b48c9dd517c6"],
//           "actionType": ["download"],
//           "contentCategory": ["premium"],
//           "limit": 5,
//           "resetInDays":90,
//           'uploadSection':["a20c98ef-ed60-4fe6-8210-56ace331e05d"]
//         }
//       ]
//     },
//     {
//       "title": "Yearly",
//       "description": "<p>https://Adil.com/<br>abcd efght <strong>this is not faire ererererer fdf</strong><del><strong>fdfafadfaf</strong></del><code><strong>fdafdafdfdf</strong></code></p>\n",
//       "price": 8000,
//       "discountedPrice": 3000,
//       "resetInDays": 365,
//       "subPremiumPlanVariationSpecification": [
//         {
//           "type": "event",
//           "contentType": ["4d25bcb8-5372-11ee-a6a5-b48c9dd517c6", "4d25bac3-5372-11ee-a6a5-b48c9dd517c6"],
//           "actionType": ["download"],
//           "contentCategory": ["non-premium"],
//           "limit": 54,
//           "resetInDays":30,
//           'uploadSection':["a20c98ef-ed60-4fe6-8210-56ace331e05d"]
//         }
//       ]
//     },
//     {
//       "title": "Yearly",
//       "description": "<p>https://muzaffar.com/<br>abcd efght <strong>this is not faire ererererer fdf</strong><del><strong>fdfafadfaf</strong></del><code><strong>fdafdafdfdf</strong></code></p>\n",
//       "price": 8000,
//       "discountedPrice": 3000,
//       "resetInDays": 365,
//       "subPremiumPlanVariationSpecification": [
//         {
//           "type": "tools",
//           "contentType": ["4d25bcb8-5372-11ee-a6a5-b48c9dd517c6", "4d25bac3-5372-11ee-a6a5-b48c9dd517c6"],
//           "actionType": ["download"],
//           "contentCategory": ["non-premium"],
//           "limit": 4,
//           "resetInDays":90,
//           'uploadSection':["a20c98ef-ed60-4fe6-8210-56ace331e05d"]
//         }
//       ]
//     },
//   ]
// }

export const isModuleExist = (moduleId) => {
  // console.log(module,subModule);
  const modules = JSON.parse(localStorage.getItem("finAdmin"))?.modules || [];
  // console.log("Data is coming",modules);
  const findMoule = modules?.find((item) => item.id === moduleId);

  // console.log("AccesDeletRead obj",findMoule)
  return findMoule;
}

export const MODULE_ID_MAP = {
  ContentMasterColor: 1,
  ContentMasterLanguage: 2,
  EventEvent: 35,
  ContentContent: 33,
  ContentMasterCampaign: 32,
  ContentMasterPostoftheDay: 31,
  RoleRoleModule: 30,
  RoleModule: 29,
  RoleUserRole: 28,
  SubscriptionCoupon: 27,
  SubscriptionSubscriptionPlan: 26,
  WebUsersWebUserMyActivity: 25,
  WebUsersSubscriptions: 24,
  WebUsersWebUsersList: 23,
  AdminUsersUsers: 22,
  NotificationsSend: 21,
  NotificationsUserGroup: 20,
  ContentMasterTemplate: 51,
  AdsContentBannerAd: 18,
  AdsContentAd: 17,
  EventMasterCategory: 16,
  EventMasterSpeaker: 14,
  TrendingTrendingKeywords: 13,
  TrendingGlobal: 12,
  TrendingSystemGenerated: 11,
  TrendingKeywords: 10,
  ContentMasterContentType: 9,
  ContentMasterSubCategory: 8,
  ContentMasterCategory: 7,
  ContentMasterTargetedContentList: 6,
  ContentMasterAMC: 5,
  ContentMasterSocialMedia: 4, // fixed name (was SocialMediaContentType)
  ContentMasterCreator: 3,
  AdsEventAd: 36,
  NotificationsInAppNotification: 37,
  AdsEventBannerAd: 38,
  AutoSharePlaylist: 39,
  AutoSharePlatform: 40,
  AutoShareOccassion: 41,
  PartnersPartners: 42,
  SubDomainSubDomainPartner: 46,
  SubDomainCalendar: 47,
  SubDomainCalendarFilter: 48,
  PersonalizationTemplate: 50,
  PersonalizationCategory: 49,
  ContentMasterTemplateDimension: 52,
  ModalModal: 53,
  AdsCampaignAd: 54,
  CalculatorCalculator: 57,
  AutoShareObjective: 59,
  AutoShareConcept: 58,
  AutoShareAdAccountApproval: 60,
  ContactUs: 61,
  PersonalizationCustomTemplate: 62,
  SubscriptionInvoice: 63,
  RoleChildRole: 64,
};


export const MODULE = Object.freeze({
  PLATFORM: "PLATFORM",
  USAGE: "USAGE",
  PREFERENCE: "PREFERENCE",
  PROFILE: "PROFILE",
  COBRAND: "COBRAND",
  TARGETED_CONTENT: "TARGETED_CONTENT",
  DASHBOARD: "DASHBOARD",
  SOCIAL_MEDIA: "SOCIAL_MEDIA",
  SEARCH: "SEARCH",
  AUTO_COBRAND: "AUTO COBRAND",
  LANGUAGE: "LANGUAGE",
  CAMPAIGN: "CAMPAIGN",
  CONTENT_CREATOR: "CONTENT_CREATOR",
  PARTNERS: "PARTNERS",
  EVENT_MASTER: "EVENT_MASTER",
  EVENT: "EVENT",
  CONTENT: "CONTENT",
  CONTACT_US: "CONTACT_US",
  CALCULATOR: "CALCULATOR",
  PERSONALIZATION: "PERSONALIZATION",
  SUB_DOMAIN: "SUB_DOMAIN",
  AUTO_SHARE: "AUTO_SHARE",
  ROLE: "ROLE",
  SUBSCRIPTION: "SUBSCRIPTION",
  WEB_USERS: "WEB_USERS",
  ADMIN_USERS: "ADMIN_USERS",
  NOTIFICATIONS: "NOTIFICATIONS",
  ADS: "ADS",
  TRENDING: "TRENDING",
});
export const FEATURE = Object.freeze({
  // Platform
  PLATFORM_EMAIL: "PLATFORM_EMAIL",
  PLATFORM_WHATSAPP: "PLATFORM_WHATSAPP",
  PLATFORM_INSTAGRAM: "PLATFORM_INSTAGRAM",
  PLATFORM_FACEBOOK: "PLATFORM_FACEBOOK",
  PLATFORM_TWITTER: "PLATFORM_TWITTER",
  PLATFORM_LINKEDIN: "PLATFORM_LINKEDIN",

  // Usage
  USAGE_BREAKDOWN: "USAGE_BREAKDOWN",

  // Preference
  PROFILE_PREFERENCE: "PROFILE_PREFERENCE",
  CONTENT_PREFERENCE: "CONTENT_PREFERENCE",
  BRANDING_PREFERENCE: "BRANDING_PREFERENCE",
  SOCIAL_PREFERENCE: "SOCIAL_PREFERENCE",
  PREFERENCE_TOGGLE: "PREFERENCE_TOGGLE",

  // Profile
  PERSONAL_DETAILS: "PERSONAL_DETAILS",
  COMPANY_DETAILS: "COMPANY_DETAILS",

  // Cobrand
  COBRAND_TEMPLATES: "COBRAND_TEMPLATES",
  PREMIUM_CONTENT_TEMPLATE: "PREMIUM_CONTENT_TEMPLATE",
  CUSTOM_TEMPLATES: "CUSTOM_TEMPLATES",
  DEFAULT_TEMPLATE_SET: "DEFAULT_TEMPLATE_SET",

  // Targeted Content
  TARGETED_CONTENT_SELECTION: "TARGETED_CONTENT_SELECTION",

  // Dashboard
  DASHBOARD_TOGGLE: "DASHBOARD_TOGGLE",

  // Social Media
  SOCIAL_MEDIA_TOGGLE: "SOCIAL_MEDIA_TOGGLE",

  // Search
  HEADER_SEARCH: "HEADER_SEARCH",
  HOME_PAGE_SEARCH: "HOME_PAGE_SEARCH",

  // Auto Cobrand
  AUTO_COBRAND_UPLOAD: "AUTO_COBRAND_UPLOAD",
  AUTO_COBRAND_EMAIL: "AUTO_COBRAND_EMAIL",
  AUTO_COBRAND_WHATSAPP: "AUTO_COBRAND_WHATSAPP",
  AUTO_COBRAND_INSTAGRAM: "AUTO_COBRAND_INSTAGRAM",
  AUTO_COBRAND_FACEBOOK: "AUTO_COBRAND_FACEBOOK",
  AUTO_COBRAND_TWITTER: "AUTO_COBRAND_TWITTER",
  AUTO_COBRAND_LINKEDIN: "AUTO_COBRAND_LINKEDIN",

  // Language
  LANGUAGE_SELECTION: "LANGUAGE_SELECTION",

  // Campaign
  CAMPAIGN_SELECTION: "CAMPAIGN_SELECTION",

  // Content Creator
  CONTENT_CREATOR_SELECTION: "CONTENT_CREATOR_SELECTION",

  // Content
  CONTENT_LIKE: "CONTENT_LIKE",
  CONTENT_SHARE: "CONTENT_SHARE",
  CONTENT_VIEW: "CONTENT_VIEW",
  CONTENT_SAVE: "CONTENT_SAVE",
  CONTENT_DOWNLOAD: "CONTENT_DOWNLOAD",
  CONTENT_COBRAND: "CONTENT_COBRAND",
  FREE_PLAYLIST: "FREE_PLAYLIST",
  PAID_PLAYLIST: "PAID_PLAYLIST",
  CANVAS_CONTENT: "CANVAS_CONTENT",
  AI_CONTENT: "AI_CONTENT",
  CUSTOM_PLAYLIST: "CUSTOM_PLAYLIST",
  MANUAL_CONTENT: "MANUAL_CONTENT",
  POST_EMAIL: "POST_EMAIL",
  POST_WHATSAPP: "POST_WHATSAPP",
  POST_INSTAGRAM: "POST_INSTAGRAM",
  POST_FACEBOOK: "POST_FACEBOOK",
  POST_TWITTER: "POST_TWITTER",
  POST_LINKEDIN: "POST_LINKEDIN",

  // Event
  EVENT_SELECTION: "EVENT_SELECTION",
  CALENDAR_SELECTION: "CALENDAR_SELECTION",

  // Content Master
  TOOLS_SELECTION: "TOOLS_SELECTION",
  CATEGORY_SELECTION: "CATEGORY_SELECTION",

  // Personalization
  PERSONALIZATION_CATEGORY: "PERSONALIZATION_CATEGORY",
  PERSONALIZATION_TOGGLE: "PERSONALIZATION_TOGGLE",

  // Notifications
  CUSTOM_NOTIFICATION: "CUSTOM_NOTIFICATION",
  USAGE_ALERT_NOTIFICATION: "USAGE_ALERT_NOTIFICATION",
  NOTIFICATION_SETTINGS: "NOTIFICATION_SETTINGS",
  EMAIL_NOTIFICATION: "EMAIL_NOTIFICATION",
  WEB_PUSH_NOTIFICATION: "WEB_PUSH_NOTIFICATION",
  SMS_NOTIFICATION: "SMS_NOTIFICATION",
  WHATSAPP_NOTIFICATION: "WHATSAPP_NOTIFICATION",

  // Ads
  ADS_CONTENT: "ADS_CONTENT",
  CONTENT_BANNER: "CONTENT_BANNER",
  EVENT_ADS: "EVENT_ADS",
  EVENT_BANNER: "EVENT_BANNER",

  // Trending
  TRENDING_TOGGLE: "TRENDING_TOGGLE",
});

export const contentMaster = "Content Master";
export const subConternMaster = {
  campaign: 'Campaign',
  postOfTheDay: 'Post of the Day',
  keywords: 'Keywords',
  contenttype: 'Content Type',
  subCategory: 'Sub Category',
  category: 'Category',
  targetedContentList: "Targeted Content List",
  AMC: 'AMC',
  socialMediaContentType: 'Social Media Content Type',
  contentCreator: 'Creator',
  language: 'Language',
  event: 'Event',
  color: "Color"
}
export const Ads = "Ads";
export const contentBannerAds = '/content-banner-ads';
export const eventBannerAds = '/event-banner-ads';
// export const contentBannerAds = '/content-banner-ads';
export const subAds = {
  contentBannerAd: 'Content Banner Ad',
  eventBannerAd: 'Event Banner Ad',
  contentAd: 'Content Ad',
}
export const Role = "Role";
export const subRole = {
  RoleModule: 'Role Module',
  Module: 'Module',
  userRole: 'User Role',
}

export const GENERIC = 'generic';
export const KEYWORD = 'keyword';


export const AdminUsers = "Admin Users";
export const VerifyContent = 'Verify Content';
export const Content = "Content";
export const EventMaster = "Event Master";
export const Notifications = "Notifications";
export const SOCIALMEDIA = "SOCIAL-MEDIA";

export const Subscription = "Subscription";
export const Sso = "Sso";

export const subCoupon = {
  coupon: 'Coupon',
  subscriptionPlan: 'Subscription Plan',
}

export const selectPosition = [
  { name: 'Top Left', val: "TOP-LEFT-CORNER" },
  { name: "Top Right", val: 'TOP-RIGHT-CORNER' },
  { name: 'Top Center', val: 'TOP-CENTER-CORNER' },
  { name: 'Bottom Left', val: 'BOTTOM-LEFT-CORNER' },
  { name: 'Bottom Right', val: 'BOTTOM-RIGHT-CORNER' },
  { name: 'Bottom Center', val: 'BOTTOM-CENTER-CORNER' },
  // { name: 'Logo top, Text Bottom',val:'' },
  // { name: 'Text top, Logo Bottom',val:'' },
  // { name: 'Full Top',val:'' },
  // { name: 'Full Bottom',val:'' },
  { name: 'Center Left', val: 'CENTER-LEFT-CORNER' },
  { name: 'Center Center', val: 'CENTER-CENTER-CORNER' },
  { name: 'Center Right', val: 'CENTER-RIGHT-CORNER' },
];
export const selectLogoPosition = [
  { label: 'Right', value: "Right" },
  { label: "Left", value: 'Left' },
  // { label: 'Center', value: 'Center' },
]

export const CANVAS_COVER_FACTOR = 8;

export const popularFonts = [
  "Roboto",
  "Lobster",
  "Arial",
  "Times New Roman",
  "Verdana",
  "Pacifico",
  "Poppins",
  "Montserrat",
  "Open Sans",
  "Oswald",
  "Raleway",
  "Dancing Script"
]

export const FILE_TYPES = {
  image: "image/*",
  video: "video/*",
  audio: "audio/*",
  pdf: "application/pdf",
  document: "application/pdf"
}

export const FILE_STARTS_WITH = {
  'image/': "image",
  'video/': "video",
  'audio/': "audio",
  'application/': "pdf",
}

export const AMC_SOCIAL_MEDIA_TYPES = {
  Youtube: 'Youtube',
}